module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: 'tech-bubble-wrapper ' + _vm.size + ' ' + _vm.icon
  }, [_c('img', {
    attrs: {
      "src": '/static/images/techicons/' + _vm.icon + '.svg'
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-21e5a6f4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/technology/components/tech-bubble.vue
// module id = 305
// module chunks = 1